
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { ContactFormService } from 'apps/console/src/app/shared-module/services';
import { of } from 'rxjs';

import * as featureActions from './actions';

@Injectable({providedIn: 'root'})
export class ContactFormStoreEffects {
	private actions$ = inject(Actions);
	private store = inject(Store);
	private contactFormService = inject(ContactFormService);


	formRequest$ = createEffect(() => this.actions$.pipe(
		ofType(featureActions.SubmitFormRequest),
		switchMap(action => this.contactFormService.submitContactForm(action.entity).pipe(
			map(_ => featureActions.SubmitFormSuccess({ entity: action.entity }),
				catchError(error => of(featureActions.SubmitFormFailure({ error })))
			))
		)));

}
